import React, { useState, useEffect } from 'react';
import { View, ScrollView } from 'react-native';
import PaperTableDynamic from '../common/controls/TableProvider';
import { getAllItems, getItemById } from '../common/service/dataOperations';
import { useAuth } from '../../../providers/AuthProvider';
import { useClient } from '../../../providers/ClientProvider';
import { Loader } from '../../Common/Loader';
import { logStyles } from './LogStyles';

interface Props {
  siteId: string;
  logTitle: string;
}
export default function PermitRegister(props: Props) {

  const [LogData, setLogData] = useState<null | any>(null);
  const [LogColumns, setLogColumns] = useState<null | any>(null);
  const { getAccessToken } = useAuth();
  const { clientName, clientAPIURL } = useClient();
  useEffect(() => {
    async function fetchData() {
      try {

        const logTitle = props.logTitle;
        const accessToken = await getAccessToken();
        const json = await getAllItems(logTitle, accessToken, clientAPIURL, props.siteId);
        setLogData(json.items);
        setLogColumns(json.columns);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  return LogData && LogColumns ? <CreateNoiseLogCharts setLogData={setLogData} LogData={LogData} LogColumns={LogColumns} siteId={props.siteId} logTitle={props.logTitle} clientAPIURL={clientAPIURL} /> : <Loader />;
}
interface CreateNoiseLogChartsProps {
  LogData: any;
  LogColumns: any;
  siteId: string;
  logTitle: string;
  clientAPIURL: string;
  setLogData: any;
}

const CreateNoiseLogCharts: React.FC<CreateNoiseLogChartsProps> = ({ setLogData, LogData, LogColumns, siteId, logTitle, clientAPIURL }) => {

  const { getAccessToken } = useAuth();
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const ColumnsWithIDColumn = LogColumns && [
    ...LogColumns,
    {
      id: 'CODE_GENERATED_ID',
      title: 'Item ID',
      columnName: 'ID',
      list: '7ae860e9-6c67-46d0-b65e-f2869542a3aa',
      datatype: 'calculated',
      createdAt: 'YOUR_CREATED_AT_TIMESTAMP',
      modifiedAt: 'YOUR_MODIFIED_AT_TIMESTAMP',
      required: false,
      subType: 'Float',
      choiceChoices: null,
      choiceType: null,
      choiceMultiselect: null,
      multiline: false,
      order: 0,
      calculatedFormula: null,
      listNavigation: null,
    }
  ];
  const updatedData = LogData;

  const [newData, setNewData] = useState<any[]>(updatedData);
  async function handleDataUpdate(item: any) {
    if (item.ID) {
      try {
        const accessToken = await getAccessToken();
        const result = await getItemById(logTitle, accessToken, clientAPIURL, siteId, item.ID)
        let data = updatedData.filter((oItem: any) => oItem.ID !== item.ID);
        const newItem = { ...result.items[0] }
        let JoinCreatedItem = [...data, newItem];
        setNewData(JoinCreatedItem);
      }
      catch (ex) {
        console.log(ex)
      }
    }
  }

  return (
    <View style={logStyles.logRoot}>
      <ScrollView>
        <View style={logStyles.container}>
          <View style={logStyles.cardThree}>
            {
              newData &&
              ColumnsWithIDColumn && (
                <PaperTableDynamic
                  data={newData}
                  columns={ColumnsWithIDColumn}
                  siteId={siteId}
                  logTitle={logTitle}
                  updateData={handleDataUpdate}
                  isConsolidatedTable={false}
                  funcSetShowFilter={setShowFilter}
                />
              )
            }
          </View>
        </View>
      </ScrollView>
    </View>
  );
};